module.exports = __webpack_public_path__ + "static/media/EmployeeManagerRelations.a37a6d24.svg";